import "./TicketMarketing.css"
import { BasicModal } from "../../../../components/Shared";
import React, { useState } from "react";

export function TicketMaterial() {
    const [showModal, setShowModal] = useState(false);
    const titleModal = "Tiempos de Espera";

    const onOpenCloseModal = () => {
        setShowModal(!showModal);
    };

    const verTiemposMaterial = () => {
        setShowModal(true);
    };

    const pdfView = (
        <iframe
            src="/pdf/TiemposTicketMaterial(eventos).pdf"
            className="pdf-frame-modal"
        />
    );

    return (
        <div className="marketing-ticket">
            <div className="pdf-button">
                <a className="pdf-open" onClick={verTiemposMaterial}>
                    Tiempos de espera
                </a>
            </div>
            <div className="preview-container">
                <div className="form-view">
                    <div className="form-view-container">
                        <iframe
                            className="form-frame-material"
                            src="https://forms.clickup.com/36614121/f/12xbz9-21834/T9I1UE4B2T2PDVNZBW"

                            title="ClickUp Form"
                        ></iframe>
                    </div>
                </div>
            </div>

            <BasicModal
                className="pdf-modal"
                show={showModal}
                close={onOpenCloseModal}
                title={titleModal}
            >
                {pdfView}
            </BasicModal>
        </div>
    );
}